/**
 * @desc Designated route layers to import into the store
 *
 * @author Mike Hamilton <mike@mikehamilton.ca>
 */

import layers from "./layers";

export default {
  modules: {
    layers
  },
  state: {
    name: "liftopsdesignatedroutes",
    deptTitle: "Lift Ops Designated Routes",
    icon: "beenhere",
    split: true,
    splitNames: [{ name: "Blackcomb" }, { name: "Whistler" }]
  }
};
